import React from 'react'
import {Field, change as changeFieldValue, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderFieldCheck, renderTextArea, required} from '../../util/inputs'
import cancelarReservas from '../../actions/reserva/cancelarReservas';
import {formatarReal} from '../../util/numberUtil';
import {houveDeterminadaExcecao, showSuccessMsg} from '../../util/messagesUtil';
import { validaPerfis } from '../../security/Autorizacao';
import {
  getAdminEmpresa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getOperadorRemarcacao,
  PERFIL_ADMIN
} from '../../security/securityContext';

export class ModalConfirmacaoCancelamentoReserva extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoReservas').modal('hide');
    $('#modalConfirmacaoCancelamentoReservas').hide();
    $('.modal-backdrop').hide();
    this.props.limparHabilitadoZerarValorMultaCancelamento();
    this.limparCancelarSomenteNoSistema();
  }

  limparCancelarSomenteNoSistema() {
    this.props.changeFieldValue('formularioCancelamentoReserva', 'cancelarSomenteNoSistema', false);
    this.props.alterarCancelarSomenteNoSistema(false);
  }

  exibirCancelarSomenteNoSistema() {
    const possuiVendaSite = this.props.reservas && this.props.reservas.some(f => f.selecionada && f.vendaSite);
    return possuiVendaSite && validaPerfis([PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
      getGestorEmpresa(this.props.empresaSelecionada.id)]);
  }

  validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() {
    return (validaPerfis([getAdminEmpresa(this.props.empresaSelecionada.id)]) ||
                (validaPerfis([getGestorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])) ||
                    (validaPerfis([getOperadorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])));
  }

  submit (values) {
    this.props.cancelarReservas(this.props.empresaSelecionada.id, values.observacao, this.props.habilitadoZerarValorMultaCancelamento, this.props.reservas.filter(f => f.selecionada)
      .map(it => it.id), this.props.cancelarSomenteNoSistema)
      .then(() => {
          showSuccessMsg('Reservas canceladas com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
      .catch((error) => {
          // Falha no estorno junto à operadora: oferece o cancelamento somente no sistema
          if (houveDeterminadaExcecao(error, 'cancelarCompraComCartao') && this.exibirCancelarSomenteNoSistema()) {
              this.props.changeFieldValue('formularioCancelamentoReserva', 'cancelarSomenteNoSistema', true);
              this.props.alterarCancelarSomenteNoSistema(true);
          }
      })
  }

  exibirTaxaRemarcacao () {
    let taxa = 0.00;
    let valorTotal = 0.00;
    let estorno = 0.00;
    let pedagio = 0.00;
    if (this.props.reservas && this.props.reservas.filter(f => f.selecionada).length > 0) {
      this.props.reservas.filter(f => f.selecionada)
        .forEach(reserva => {
          if (this.validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() && this.props.habilitadoZerarValorMultaCancelamento) {
            taxa = 0.00;
          } else {
            taxa += Number(reserva.valorTaxaCancelamento);
          }
          pedagio += Number(reserva.pedagio);
          valorTotal += formatarReal(reserva.taxaEmbarque) ? (Number(reserva.taxaEmbarque) + Number(reserva.tarifaSeguro) + Number(reserva.valor)) : reserva.valor;
        })
      estorno = valorTotal - taxa + pedagio;
    }

    const fmt = v => v.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

    return (
      <div className="vx-modal-finance-grid">
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Total</span>
          <span className="vx-modal-finance-value">{fmt(valorTotal)}</span>
        </div>
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Taxa</span>
          <span className="vx-modal-finance-value">{fmt(taxa + pedagio)}</span>
        </div>
        <div className="vx-modal-finance-card">
          <span className="vx-modal-finance-label">Estorno</span>
          <span className="vx-modal-finance-value">{fmt(estorno)}</span>
        </div>
      </div>
    );
  }

  exibirReservas () {
    return (
      <div className="vx-modal-reservas">
        <p className="vx-modal-reservas-label">Reservas selecionadas</p>
        <ul className="vx-modal-reservas-list">
          {this.props.reservas.filter(f => f.selecionada).map(reserva => (
            <li key={reserva.id} className="vx-modal-reservas-item">
              <span className="material-icons">arrow_forward</span>
              <div>
                <div className="vx-modal-reservas-route">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</div>
                <div className="vx-modal-reservas-pax">{reserva.passageiroDto.nome}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoReservas" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoReservas" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">cancel</span>
                Confirmar Cancelamento
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar"
                      onClick={() => {
                        this.props.changeFieldValue('formularioCancelamentoReserva', 'habilitadoZerarValorMultaCancelamento', false);
                        this.props.limparHabilitadoZerarValorMultaCancelamento();
                        this.limparCancelarSomenteNoSistema();
                      }}>
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada) ?
                  <React.Fragment>
                    {this.exibirTaxaRemarcacao()}
                    {this.validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() &&
                      <div className="vx-modal-check-area">
                        <Field name="habilitadoZerarValorMultaCancelamento" type="checkbox"
                               component={renderFieldCheck}
                               label="Zerar valor de multa cancelamento"
                               css="form-check-input" readOnly={false} className="form-check-input"
                               onChange={(e) => this.props.handleHabilitadoZerarValorMultaCancelamento(e)}/>
                      </div>
                    }
                    {this.exibirCancelarSomenteNoSistema() &&
                      <div className="vx-modal-check-area">
                        <Field name="cancelarSomenteNoSistema" type="checkbox"
                               component={renderFieldCheck}
                               label="Cancelar somente no sistema (sem estorno na operadora de cartão/PIX)"
                               css="form-check-input" readOnly={false} className="form-check-input"
                               onChange={(e) => this.props.alterarCancelarSomenteNoSistema(e.target.checked)}/>
                      </div>
                    }
                    {this.exibirCancelarSomenteNoSistema() && this.props.cancelarSomenteNoSistema &&
                      <div className="vx-modal-alert-warning">
                        <p className="vx-modal-alert-warning-title">⚠️ Atenção: Cancelamento não realizado na operadora</p>
                        <p>Não foi possível cancelar os valores junto à operadora de pagamento.</p>
                        <p>Você pode continuar com o cancelamento somente no Sistema Vexado, mas atenção: essa ação não cancela nem estorna automaticamente o pagamento na operadora.</p>
                        <p>Para concluir o cancelamento financeiro, será necessário acessar o painel de gestão da operadora ou entrar em contato diretamente com o suporte responsável.</p>
                        <p className="vx-modal-alert-warning-question">Deseja confirmar o cancelamento somente no sistema?</p>
                      </div>
                    }
                    {this.exibirReservas()}
                    <p className="vx-modal-obs-label">Motivo do cancelamento</p>
                    <Field name='observacao' css="form-control" component={renderTextArea}
                           max={1500} validate={[required]} className="form-control"
                           label=""/>
                  </React.Fragment>
                : ''}
              </div>
              <div className="vx-modal-footer">
                <button id='cancelar' type="button" className="vx-modal-btn-fechar"
                        data-dismiss="modal"
                        onClick={() => {
                          this.props.changeFieldValue('formularioCancelamentoReserva', 'habilitadoZerarValorMultaCancelamento', false);
                          this.props.limparHabilitadoZerarValorMultaCancelamento();
                          this.limparCancelarSomenteNoSistema();
                        }}>
                  Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar">
                  <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
                  {this.props.cancelarSomenteNoSistema ? 'Sim, cancelar somente no sistema' : 'Sim, cancelar'}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarReservas,
  changeFieldValue
})(reduxForm({
  form: 'formularioCancelamentoReserva',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoReserva));
